import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import forgotpassword from './ForgotPassword.module.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        const auth = getAuth();
        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('Password reset email sent!');
        } catch (error) {
            setMessage(`Error: ${error.message}`);
        }
    };

    return (
        <div className={forgotpassword['forgot-password-container']}>
            <div className={forgotpassword['forgot-password-form']}>
                <h2>Forgot Password</h2>
                <form onSubmit={handlePasswordReset}>
                    <div className={forgotpassword['form-group']}>
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <button type="submit" className={forgotpassword['forgot-password-button']}>Reset Password</button>
                </form>
                {message && <p>{message}</p>}
            </div>

            <div className={forgotpassword['forgot-password-footer']}>
                <a href="/login" className={forgotpassword['text-link']}>Return to Sign In</a>
            </div>
        </div>
    );
};

export default ForgotPassword;